<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
    >
        <v-card>
            <div class="info-block info-block--default">
                <div class="header-default-mode">
                    <h1>Request Footage</h1>
                </div>
                <div class="close" @click="dialog = !dialog">
                    <i class="material-icons">close</i>
                </div>
            </div>

            <v-container class="content-container">
                <v-layout row>
                    <div class="wrapper">
                        <v-layout row>
                            <v-flex md12>
                            <div class="box" style="height: inherit">
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                >
                                    <div class="content">
                                        <datetime
                                            v-model="form.datetime"
                                            type="datetime"
                                            format="yyyy-MM-dd, HH:mm"
                                            placeholder="Choose date and time"
                                            :max-datetime="maxAvailableDate"
                                            hide-backdrop
                                            class="datetime-picker"
                                        ></datetime>
                                        <sp-select v-model="form.channels" :items="channels" item-value="id" item-text="key" multiple :hide-details="true" placeholder="Choose channels" class="channel-select"></sp-select>
                                        <sp-select v-model="form.duration" :items="durations" item-value="value" item-text="text"></sp-select>
                                        <div class="flex">
                                            <v-layout row justify-space-between>
                                                <v-flex md6 align-self-center>
                                                    <sp-switch
                                                        v-model="form.overlay"
                                                        :color="form.overlay ? 'red' : ''"
                                                        :value="form.overlay"
                                                        label="With overlay"
                                                        className="switch--white small-field"
                                                        class="small-field"
                                                    ></sp-switch>
                                                </v-flex>
                                                <v-flex md6>
                                                    <div class="request-button">
                                                        <sp-button @click.native="requestMedia" sp-class="no-padding-right" icon="settings" text="Request video"></sp-button>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </div>
                                </v-form>
                            </div>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-layout>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

import Calendar from '@/components/atoms/Calendar'
import Select from '@/components/atoms/Select'
import Switch from '@/components/atoms/Switch'
import Time from '@/components/atoms/Time'
import Button from '@/components/forms/Button'
import { Datetime } from 'vue-datetime'
import { DeviceApi, DeviceCommandApi } from '@/api'

import { mapGetters } from 'vuex'
import moment from 'moment'
import toast from '../../plugins/izitoast'

const deviceApi = new DeviceApi()
const deviceCommandApi = new DeviceCommandApi()

export default {
    name: 'RequestFootageDialog',
    mounted () {
        this.maxAvailableDate = moment().format('YYYY-MM-DDTHH:mm:ssZ').toString()
    },
    components: {
        Datetime,
        'sp-select': Select,
        'sp-switch': Switch,
        'sp-button': Button
    },
    data () {
        return {
            valid: false,
            maxAvailableDate: '',
            channels: [],
            rules: {
                date: [
                    v => !!v || 'cannot be empty'
                ]
            },
            durations: [
                {
                    'value': 10,
                    'text': '10s'
                },
                {
                    'value': 20,
                    'text': '20s'
                },
                {
                    'value': 30,
                    'text': '30s'
                },
                {
                    'value': 40,
                    'text': '40s'
                },
                {
                    'value': 50,
                    'text': '50s'
                },
                {
                    'value': 60,
                    'text': '1m'
                },
                {
                    'value': 70,
                    'text': '1m 10s'
                },
                {
                    'value': 80,
                    'text': '1m 20s'
                },
                {
                    'value': 90,
                    'text': '1m 30s'
                },
                {
                    'value': 100,
                    'text': '1m 40s'
                },
                {
                    'value': 110,
                    'text': '1m 50s'
                },
                {
                    'value': 120,
                    'text': '2m'
                }
            ],
            form: {
                datetime: '',
                channels: '',
                duration: '',
                overlay: true
            }
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        date: {
            type: [Object, String],
            required: false
        },
        journey: {
            type: Object
        }
    },
    computed: {
        ...mapGetters({
            getChannels: 'dictionaryModule/getChannels'
        }),
        dialog: {
            get () { return this.value },
            set (value) { this.$emit('input', value) }
        }
    },
    watch: {
        value: {
            async handler () {
                this.channels = []
                this.form = {
                    datetime: '',
                    channels: '',
                    overlay: true,
                    duration: 10
                }
                if (this.value) {
                    this.$store.state.isOverlayActive = true
                    await this.getDeviceInfo()
                    this.form.datetime = moment().format()
                    this.$store.state.isOverlayActive = false
                }
            }
        }
    },
    methods: {
        async getDeviceInfo () {
            const response = await deviceApi.getDevice(this.journey.hardwareId)

            const channelsFlag = (response.payload.channelFlag >>> 0).toString(2).split('').reverse()

            this.channels = this.getChannels.filter((channel) => {
                return 0 !== channel.id
            }).filter((channel, index) => {
                if (0 === channelsFlag[index] || null == channelsFlag[index]) {
                    return
                }

                return channel.id === Math.pow(2, index)
            })
        },
        async requestMedia () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return
            }
            const date = this.form.datetime

            const response = await deviceCommandApi.requestVideo({
                hardwareId: this.journey.hardwareId,
                date: date,
                channels: 0 === this.form.channels.length ? 0 : this.form.channels.reduce((a, b) => a + b, 0),
                videoLengthInSeconds: this.form.duration,
                withOverlay: this.form.overlay
            })

            if (response.isSuccess) {
                toast.success('Media request send')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.v-card {
    .info-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        h1 {
            font-size: 16px;
            font-weight: 400;
        }
    }
}
.close {
    position: static;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}
.wrapper {
    width: 100%;
}
::v-deep .datetime-picker {
    border: 1px solid rgba(0,0,0,0.54);
    border-radius: 8px;
    height: 50px;
    margin-bottom: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    .vdatetime-popup__header,
    .vdatetime-calendar__month__day--selected > span > span,
    .vdatetime-calendar__month__day--selected:hover > span > span {
        background: $secondary;
    }
    .vdatetime-year-picker__item--selected,
    .vdatetime-time-picker__item--selected,
    .vdatetime-popup__actions__button {
        color: $primary;
    }
}
::v-deep .v-dialog {
    overflow: visible;
}
::v-deep .datetime-picker > div {
    position: relative;
    width: 100%;
    .vdatetime-popup {
        position: absolute;
        top: 10px;
        left: 0;
        min-width: 340px;
        max-width: auto;
        transform: translateX(-50%)
    }
}
</style>
